import { makeStyles, alpha } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: '20px',
    width: '100%',
    height: '100%',
    overflowY: 'auto'
  },
  loadingText: {
    fontSize: '16px',
    color: theme.palette.grey[600],
    textAlign: 'center',
    padding: '40px 0'
  },
  emptyText: {
    fontSize: '16px',
    color: theme.palette.grey[600],
    textAlign: 'center',
    padding: '40px 0'
  },
  cardList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  card: {
    border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`,
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)'
    }
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px'
  },
  date: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.primary.main
  },
  daysCount: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.primary.main,
    padding: '4px 12px'
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column'
  },
  weight: {
    fontSize: '18px',
    fontWeight: 500,
    color: alpha('rgba(0,0,0,0.5)', 0.5)
  }
}))
